export default __webpack_public_path__ + "static/saml_device-4fd87f2f38436051a57de9056dbab269.gif";